import PageRequest from '@/api/Main/dataSource/api/pagination-helper/lib/PageRequest';
import BaseProjectResponse from '@/api/Main/dataSource/api/projects/base/i-service/models/BaseProjectResponse';
import ProjectGetBuIdRequest from '@/api/Main/dataSource/api/projects/base/i-service/models/ProjectGetBuIdRequest';
import GetTaskListByTreeShortRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetTaskListByTreeShortRequest';
import SortingSettingsTask from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/SortingSettingsTask';
import GetTaskListRequestFilter from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetTaskListRequestFilter';
import GetByIdRequest from '@/api/Main/dataSource/api/users/base/i-service/models/requests/GetByIdRequest';
import GetByIdResponse from '@/api/Main/dataSource/api/users/base/i-service/models/responses/GetByIdResponse';
import { ProjectModel, UserModel, PaginationResponseModel } from '@/models';
import { TaskSortingEnum } from '../enums';
import { GetProjectTasksRequestModel } from '../models';
import GetTaskListByTreeShortResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetTaskListByTreeShortResponse';
import { TaskModel, TaskPersonModel, TaskQueueModel } from '@/components/tasks-kanban/models';
import GetTaskListByTreeShortResponseItem from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetTaskListByTreeShortResponseItem';
import { TaskParameterModel } from '@/components/task-parameter/models';

export const mapGetProjectRequest = (projectId: number) =>
  new ProjectGetBuIdRequest({
    ProjectId: projectId,
  });

export const mapGetProjectResponse = (response: BaseProjectResponse) =>
  new ProjectModel({
    Id: response.Id,
    Name: response.Name,
    PreviewColor: response.PreviewColor,
    ImageUrl: response.ImageUrl,
  });

export const mapGetEmployeeRequest = (employeeId: number) =>
  new GetByIdRequest({
    UserId: employeeId,
  });

export const mapGetEmployeeResponse = (response: GetByIdResponse) =>
  new UserModel({
    Id: response.UserId,
    FirstName: response.FirstName,
    LastName: response.LastName,
    MiddleName: response.MiddleName,
    ImageUrl: response.Foto,
    AvatarColor: response.AvatarColor,
  });

export const mapGetTasksByProjectIdRequest = (request: GetProjectTasksRequestModel) =>
  new GetTaskListByTreeShortRequest({
    ProjectId: !request.Filter.Namespaces?.length ? request.ProjectId : undefined,
    NamespaceId: request.Filter.Namespaces?.length ? request.Filter.Namespaces[0] : undefined,
    Filter: new GetTaskListRequestFilter({
      Search: request.Filter.Search,
      StatusId: request.Filter.Statuses,
      PriorityId: request.Filter.Priorities,
      PerformerIds: request.Filter.Performers,
      ObserverIds: request.Filter.Observers,
      AuthorIds: request.Filter.Authors,
    }),
    Page: request.Page
      ? new PageRequest({
          Take: request.Page.Take,
          Skip: request.Page.Skip,
        })
      : undefined,
    SortingSettings: new SortingSettingsTask({
      OrderDescendingByName: request.Sort.OrderByName,
      OrderDescendingByTaskId: request.Sort.OrderById,
      OrderDescendingByEstimates: request.Sort.OrderByEstimateTime,
      OrderDescendingBySpent: request.Sort.OrderByWorkTime,
    }),
  });

export const mapGetTasksByProjectIdResponse = (response: GetTaskListByTreeShortResponse) =>
  new PaginationResponseModel<Array<TaskModel>>({
    Current: response.Page.Current,
    Count: response.Page.Count,
    Size: response.Page.Size,
    IsSuccess: true,
    Items: response.Items.map((item) => mapTaskModel(item, item.ProjectId, true)),
  });

/**Получение модели задачи */
export const mapTaskModel = (
  item: GetTaskListByTreeShortResponseItem,
  projectId?: number,
  isTreeShortResponse?: boolean,
) => {
  const task = new TaskModel({
    Id: item.Id,

    ProjectId: projectId,
    EstimateTime: item.EstimateTime,
    WorkTime: item.WorkTime,
    Name: item.Name,
    // Difficulty: new DifficultyLevelTaskModel({
    //   DifficultyId: item?.Difficulty?.DifficultyId,
    //   DifficultyColor: item?.Difficulty?.DifficultyColor,
    //   DifficultyName: item?.Difficulty?.DifficultyName,
    // }),

    Status: new TaskParameterModel({
      Id: item.Status?.StatusId,
      Name: item.Status?.StatusName,
      Color: item.Status?.StatusColor,
    }),
    Priority: new TaskParameterModel({
      Id: item.Priority?.PriorityId,
      Name: item.Priority?.PriorityName,
      Color: item.Priority?.PriorityColor,
    }),
  });

  if (isTreeShortResponse) {
    item = item as GetTaskListByTreeShortResponseItem;
    Object.assign(task, {
      ProjectId: item.ProjectId || projectId,
      Queues: item.QueueTaskList.map(
        (queue) =>
          new TaskQueueModel({
            Id: queue.Id,
            Name: queue.Name,
            NamespaceId: queue.Namespace.Id,
          }),
      ),
      NamespaceInfo: item.QueueTaskList.map((queue) => queue.Namespace),
      Author: new TaskPersonModel({
        Id: item.Owner.Id,
        FirstName: item.Owner.FirstName,
        LastName: item.Owner.LastName,
        MiddleName: item.Owner.MiddleName,
        ImageUrl: item.Owner.Photo,
        NoPhotoColor: item.Owner.AvatarColor,
      }),
    });
  }
  return task;
};
